import React from 'react';
import { TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../app/hooks';
import { updateVendorIdentification } from '../../../state/vendorSlice';

const CompanyNameEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentVendor } = useAppSelector(state => state.vendor);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateVendorIdentification({ companyName: event.target.value }));
  };

  return (
    <TextField
      label="Company Name"
      size="small"
      required
      fullWidth
      value={currentVendor?.companyName || ''}
      onChange={handleChange}
    />
  );
};

export default CompanyNameEdit;
